import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/takeUntil';
import { AdminService } from '../../../services/admin.service';
import { Schedule } from '../../../models/schedule.model';
import { TimeFormatterService } from '../../../services/time-formatter.service';;
import {
  CurrencyCode,
  CurrencyCodes,
  PAYROLL_CURRENCY_CODES,
  trackByCurrencyCode
} from '../../../models/payroll-currency.model';
import { HttpStatus } from '../../../shared.constants/all-constants';
import { GroupCreationRequest } from './create-group.option';

const GROUP_TYPES = {
	GLOBAL: 'GLOBAL',
	AFFILIATE: 'AFFILIATE',
	DEPARTMENT: 'DEPARTMENT'
};
const FEEDBACK_DISMISS_DELAY = 2000;

@Component({
	selector: 'app-create-group',
	templateUrl: './create-group.component.html',
	styleUrls: ['./create-group.component.css']
})

export class CreateGroupComponent implements OnInit, OnDestroy {
	public successInfo = false;
	public errorInfo = false;
	public errorGetScheduleInfo = false;
	public errorValidateInfo = false;
	getSubdivisionsErrorInfo = false;
	getAffiliatesErrorInfo = false;
	noSubdivisionsInfo = false;
	noAffiliatesInfo = false;
	isDepartmentsLoaded = false;
	isAffiliatesLoaded = false;
	selectedSchedule: Schedule;
	selectedScheduleName = 'Select';

	private scheduleIDProp = null;

	schedulesList: any[] = [];
	schedulesListNoFormated;

	isAffiliate = false;
	isDepartment = false;
	isGlobal = false;
	// groupTypes = ['GLOBAL', 'AFFILIATE', 'DEPARTMENT'];
	groupTypes = [GROUP_TYPES.DEPARTMENT];
	subdivisions = [];
	affiliates = [];
	selectedType = '';
	selectedSubdivision = '';
	selectedSubdivisionId = '';
	selectedAffiliate = '';
	selectedAffiliateId = '';
	titleValue = '';
	prefixvalue = '';
	selectedPayrollCurrency: CurrencyCode = CurrencyCodes.BYN;
	payrollCurrencies = PAYROLL_CURRENCY_CODES;
	trackByCurrency = trackByCurrencyCode;
	isCreateBtnDisabled = true;
	isCreateBtnDisabledPre = true;
	errorName = false;
	private destroy$ = new Subject<void>();

	selectedSubdivisions = [];

	constructor(private adminService: AdminService, private formatService: TimeFormatterService) { }

	ngOnInit() {
		this.getScheds();
		this.selectType(GROUP_TYPES.DEPARTMENT);
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	titleValueEmpty(value) {
		value = value.trim();
		if (value !== '' && value !== undefined && value !== '') {
			this.isCreateBtnDisabled = false;
		} else {
			this.isCreateBtnDisabled = true;
		}
	}

	prefixValueEmpty(value) {
		value = value.trim();
		if (value !== '' && value !== undefined && value !== '') {
			this.isCreateBtnDisabledPre = false;
		} else {
			this.isCreateBtnDisabledPre = true;
		}
	}

	getScheds() {
		this.adminService.getSchedules().subscribe(
			(response) => {
				this.schedulesListNoFormated = response.body;
			},
			() => {
				this.errorGetScheduleInfo = true;
			},
			() => {
				// this.schedulesListNoFormated.forEach(item => {
				//   this.schedulesList.push(this.formatService.formatTime(item));
				// });
				this.selectedSched(this.schedulesListNoFormated[0]);
			}
		);
	}

	getDepartments() {
		this.adminService.getDepartmentGroups().subscribe(
			(response: any) => {
				this.subdivisions = response.body;
				this.getSubdivisionsErrorInfo = false;
				if (this.subdivisions.length > 0) {
					this.noSubdivisionsInfo = false;
					this.selectedSubdivisions = [];
				} else {
					this.noSubdivisionsInfo = true;
					this.selectedSubdivision = "NO_SUBDIVISIONS";
				}
				this.isDepartmentsLoaded = true;
			},
			() => {
				this.noSubdivisionsInfo = true;
				this.getSubdivisionsErrorInfo = true;
				this.isDepartmentsLoaded = true;
				this.selectedSubdivision = "C_A_S";
			}
		);
	}

	getAffiliates() {
		this.adminService.getAffiliateGroups().subscribe(
			(response: any) => {
				this.affiliates = response.body;
				this.getAffiliatesErrorInfo = false;
				if (this.affiliates.length > 0) {
					this.noAffiliatesInfo = false;
					this.selectAffiliate(this.affiliates[0]);
				} else {
					this.noAffiliatesInfo = true;
					this.selectedAffiliate = "NO_AFFILIATE_GROUPS";
				}
				this.isAffiliatesLoaded = true;
			},
			() => {
				this.noAffiliatesInfo = true;
				this.getAffiliatesErrorInfo = true;
				this.isAffiliatesLoaded = true;
				this.selectedAffiliate = "C_A_G";
			}
		);
	}

	selectedSched(schedule: Schedule) {
		this.selectedScheduleName = schedule.workStart.substr(0, schedule.workStart.length - 3) + ' - ' + schedule.workEnd.substr(0, schedule.workEnd.length - 3);
		this.scheduleIDProp = schedule.id;
		this.selectedSchedule = schedule;
	}

	selectType(type) {
		if (type == 'AFFILIATE') {
			this.isAffiliate = true;
			this.isDepartment = false;
			this.isGlobal = false;
			if (!this.isDepartmentsLoaded) {
				this.getDepartments();
			}
		}
		if (type == 'DEPARTMENT') {
			this.isAffiliate = false;
			this.isDepartment = true;
			this.isGlobal = false;
			this.selectedSubdivisions = [];
			if (!this.isAffiliatesLoaded) {
				this.getAffiliates();
			}
		}
		if (type == 'GLOBAL') {
			this.selectedSubdivisions = [];
			this.isGlobal = true;
			this.isAffiliate = false;
			this.isDepartment = false;
			if (!this.isAffiliatesLoaded) {
				this.getAffiliates();
			}
		}
		this.selectedType = type;
	}

	selectSubdivision(subdivision) {
		this.selectedSubdivision = subdivision.name;
		this.selectedSubdivisionId = subdivision.id;
	}

	selectAffiliate(affiliate) {
		this.selectedAffiliate = affiliate.name;
		this.selectedAffiliateId = affiliate.id;
	}

	appendSubdivision(subdivision) {

		if (this.selectedSubdivisions.includes(subdivision)) {
			const index: number = this.selectedSubdivisions.indexOf(subdivision);
			if (index !== -1) {
				this.selectedSubdivisions.splice(index, 1);
			}
		} else {
			this.selectedSubdivisions.push(subdivision);
		}
	}

	isSelectedSubdivision(subdivision) {
		return this.selectedSubdivisions.includes(subdivision);
	}

	createDivision(name: string, prefix: string): void {
		this.titleValue = name;
		this.prefixvalue = prefix;
		this.adminService.createGroup(this.createGroupRequest())
			.takeUntil(this.destroy$)
			.subscribe(
				(response: HttpResponse<string>) => this.handleGroupCreated(response),
				() => this.handleGroupCreationFailed()
			);
	}

	private createGroupRequest(): GroupCreationRequest {
		return {
			name: this.titleValue,
			namePrefixStandard: this.prefixvalue,
			workScheduleId: this.selectedSchedule.id,
			groupType: this.selectedType,
			payrollCurrency: this.selectedPayrollCurrency,
			relativeGroup: this.getRelativeGroupsForSelectedType()
		};
	}

	private getRelativeGroupsForSelectedType(): Array<string | object> {
		if (this.selectedType === GROUP_TYPES.GLOBAL || this.selectedType === GROUP_TYPES.AFFILIATE) {
			return this.selectedSubdivisions;
		}
		if (this.selectedType === GROUP_TYPES.DEPARTMENT) {
			return [this.selectedAffiliateId];
		}
		return [this.selectedSubdivisionId];
	}

	private handleGroupCreated(response: HttpResponse<string>): void {
		if (response.status !== HttpStatus.CREATED) {
			return;
		}
		this.successInfo = true;
		this.errorInfo = false;
		this.errorName = false;
		this.getDepartments();
		this.getAffiliates();
		this.dismissFeedback(() => this.successInfo = false);
	}

	private handleGroupCreationFailed(): void {
		this.successInfo = false;
		this.errorInfo = true;
		this.dismissFeedback(() => this.errorInfo = false);
	}

	private dismissFeedback(reset: () => void): void {
		Observable.timer(FEEDBACK_DISMISS_DELAY)
			.takeUntil(this.destroy$)
			.subscribe(() => reset());
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-group/create-group.component.ts